export const APPLE_SIGN_IN_LOCAL_STORAGE_KEY = 'keakie-apple-login-details';

// Login type keys
export const LOGIN_TYPE_FACEBOOK = 'facebook';
export const LOGIN_TYPE_APPLE = 'apple';
export const LOGIN_TYPE_SHADOW = 'shadow';